import DefaultRenderProperties from '@Assets/RenderProperties.json';

let renderPropertyKeys = Object.keys(DefaultRenderProperties);
export function setRenderProperties(properties) {
	if (localStorage) {
		localStorage.setItem('renderProperties', JSON.stringify(properties));
	}
}

export function getRenderProperties(props, useDefault) {
	if (import.meta.env.VITE_ADVANCED_TOOLING_ENABLED === 'false') {
		useDefault = true;
	}
	if (useDefault !== true && localStorage) {
		let properties = localStorage.getItem('renderProperties');
		if (properties) {
			let p = JSON.parse(properties);
			p = mergeProperties(p, DefaultRenderProperties, renderPropertyKeys)
			p = mergeProperties(props, p, renderPropertyKeys);
			if (p.width) {
				p.width = parseInt(p.width);
			}
			if (p.height) {
				p.height = parseInt(p.height);
			}
			return p;
		}
	}
	let p = JSON.parse(JSON.stringify(DefaultRenderProperties));
	p = mergeProperties(props, p, renderPropertyKeys);
	if (p.width) {
		p.width = parseInt(p.width);
	}
	if (p.height) {
		p.height = parseInt(p.height);
	}
	return p;
}
export function mergeProperties(n, o, keys = renderPropertyKeys) {
	let result = {};
	for (let k of keys) {
		result[k] = n[k] ?? o[k];
	}
	return result;
}